import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router'

import { UtenteParams } from "./UtenteParams"
import { UtenteViewModel } from '../../models/UtenteModels'
import { UtenteEditComponent } from './UtenteEditComponent'


class UtenteEditState extends UtenteViewModel {
    ModalVisible: boolean = false
}

export class PageUtenteEdit extends React.Component<RouteComponentProps<UtenteParams>, UtenteEditState> {

    render() {
        return (
            <UtenteEditComponent backPath="/Utenti" currentPath={(idUtente) => `/Utente/Modifica/${idUtente}`} />
        )
    }
}

interface UtenteClienteParams extends UtenteParams {
    idCliente: string
}

export class PageUtenteClienteEditComp extends React.Component<RouteComponentProps<UtenteClienteParams>, UtenteEditState> {

    render() {
        const clienteId = this.props.match.params.idCliente
        console.log(clienteId)
        return (
            <UtenteEditComponent
                backPath={`/Cliente/Scheda/${clienteId}`}
                currentPath={(idUtente) => `/UtenteCliente/Modifica/${clienteId}/${idUtente}`}
                clienteId={clienteId} />
        )
    }
}

export const PageUtenteClienteEdit = withRouter(PageUtenteClienteEditComp)
